import $ from 'jquery';
const { registerBlockType } = wp.blocks;
const { RichText, MediaUpload, MediaUploadCheck, InspectorControls } =
  wp.blockEditor;
const { Button, Icon, PanelBody, SelectControl } = wp.components;
const { Fragment, useEffect } = wp.element;
const { __ } = wp.i18n;
import stepperSlider from '../../../resources/scripts/module/stepper-slider';

const BlockEdit = ({ attributes, setAttributes }) => {
  const { slides, uniqueSliderId } = attributes;

  if (!uniqueSliderId) {
    const newId = 'stepper-slider-' + Math.floor(Math.random() * 1000);
    setAttributes({ uniqueSliderId: newId });
  }

  useEffect(() => {
    if (!uniqueSliderId) {
      return;
    }

    if (!slides.length) {
      return;
    }

    stepperSlider();
  }, [slides.length, uniqueSliderId]);

  const addSlide = () => {
    const newSlides = [
      ...slides,
      {
        eyebrow: '',
        title: '',
        description: '',
        imgUrl: '',
        imgAlt: '', // Added imgAlt for the alt text
        stepTitle: '',
      },
    ];
    setAttributes({ slides: newSlides });
    const slider = $(`#${uniqueSliderId}`);
    if (slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
  };

  const removeSlide = (index) => {
    const newSlides = slides.filter((_, i) => i !== index);
    setAttributes({ slides: newSlides });
    const slider = $(`#${uniqueSliderId}`);
    if (slider.hasClass('slick-initialized')) {
      slider.slick('unslick');
    }
  };

  const updateSlide = (index, updates) => {
    const newSlides = slides.map((slide, i) =>
      i === index ? { ...slide, ...updates } : slide
    );
    setAttributes({ slides: newSlides });

    const slider = $(`#${uniqueSliderId}`);
    slider.trigger('updateTitle');
  };

  const getSlideContent = (slide, index) => (
    <div
      className="stepper-slide content-left-top"
      data-step-title={slide.stepTitle}
      key={index}
    >
      {slide.imgUrl && <img src={slide.imgUrl} alt={slide.imgAlt || ''} />}{' '}
      {/* Use alt attribute */}
      <MediaUploadCheck>
        <MediaUpload
          onSelect={
            (media) =>
              updateSlide(index, { imgUrl: media.url, imgAlt: media.alt || '' }) // Capture imgUrl and imgAlt
          }
          allowedTypes={['image']}
          value={slide.imgUrl}
          render={({ open }) => (
            <Button
              onClick={open}
              isPrimary
              className={'addButton rightTopButton'}
            >
              {slide.imgUrl ? (
                <>
                  <Icon icon="edit" /> {__('Change Image')}
                </>
              ) : (
                <>
                  <Icon icon="format-image" /> {__('Add Image')}
                </>
              )}
            </Button>
          )}
        />
      </MediaUploadCheck>
      <div className="content">
        <RichText
          tagName="p"
          className="h2-eyebrow"
          value={slide.eyebrow}
          keepPlaceholderOnFocus={true}
          onChange={(eyebrow) => updateSlide(index, { eyebrow })}
          placeholder={__('Enter eyebrow...')}
        />
        <div>
          <RichText
            tagName="h3"
            value={slide.title}
            keepPlaceholderOnFocus={true}
            onChange={(title) => updateSlide(index, { title })}
            placeholder={__('Enter title...')}
          />

          <div className={'description'}>
            <RichText
              tagName="p"
              className="description"
              keepPlaceholderOnFocus={true}
              value={slide.description}
              onChange={(description) => updateSlide(index, { description })}
              placeholder={__('Enter description here...')}
            />
          </div>
        </div>
      </div>
      <Button
        isSmall
        isPrimary
        onClick={() => removeSlide(index)}
        className="removeStaticButton rightBottomButton"
      >
        <Icon icon="no-alt" /> {__('Remove Slide')}
      </Button>
    </div>
  );

  return (
    <Fragment>
      <InspectorControls>
        <PanelBody title={__('Section Styling')}>
          <SelectControl
            label={__('Section Class')}
            value={attributes.sectionClass}
            options={[
              { label: 'Dark Secondary', value: 'section-dark-secondary' },
              { label: 'Dark Primary', value: 'section-dark-primary' },
              { label: 'Light Primary', value: 'section-light-primary' },
              { label: 'Light Secondary', value: 'section-light-secondary' },
            ]}
            onChange={(value) => setAttributes({ sectionClass: value })}
          />
          <SelectControl
            label={__('Corner Position')}
            value={attributes.cornerPositionClass}
            options={[
              { label: 'None', value: 'corner-disabled' },
              { label: 'Left-Top', value: 'corner-left-top' },
              { label: 'Left-Bottom', value: 'corner-left-bottom' },
              { label: 'Right-Top', value: 'corner-right-top' },
              { label: 'Right-Bottom', value: 'corner-right-bottom' },
            ]}
            onChange={(value) => setAttributes({ cornerPositionClass: value })}
          />
          <SelectControl
            label={__('Corner Background')}
            value={attributes.cornerBackgroundClass}
            options={[
              { label: 'Dark Primary', value: 'corner-on-dark-primary' },
              { label: 'Dark Secondary', value: 'corner-on-dark-secondary' },
              { label: 'Light Primary', value: 'corner-on-light-primary' },
              { label: 'Light Secondary', value: 'corner-on-light-secondary' },
            ]}
            onChange={(value) =>
              setAttributes({ cornerBackgroundClass: value })
            }
          />
          <SelectControl
            label={__('Slides Color')}
            value={attributes.slidesColorClass}
            options={[
              { label: 'Dark Primary', value: 'slides-dark-primary' },
              { label: 'Dark Secondary', value: 'slides-dark-secondary' },
              { label: 'Light Primary', value: 'slides-light-primary' },
              { label: 'Light Secondary', value: 'slides-light-secondary' },
            ]}
            onChange={(value) => setAttributes({ slidesColorClass: value })}
          />
        </PanelBody>

        <PanelBody title={__('Slider Settings')}>
          <Button isPrimary onClick={addSlide}>
            <Icon icon="insert" /> {__('Add Slide')}
          </Button>
        </PanelBody>
      </InspectorControls>
      <section className={attributes.sectionClass}>
        <div
          className={`corner ${attributes.cornerPositionClass} ${attributes.sectionClass.replace(
            'section',
            'corner'
          )} ${attributes.cornerBackgroundClass}`}
        ></div>
        <div
          className={`stepper-slider-wrapper ${attributes.slidesColorClass}`}
        >
          <div className="slider-container">
            <div className="list-wrapper">
              <div className="stepper-container"></div>
              <div
                className="list"
                data-slider="stepper-slider"
                id={uniqueSliderId}
              >
                {slides &&
                  slides.length &&
                  slides.map((slide, index) => getSlideContent(slide, index))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

registerBlockType('pg/stepper-slider', {
  title: 'PG Stepper Slider',
  icon: 'slides',
  category: 'layout',
  supports: {
    html: false,
  },
  attributes: {
    slides: {
      type: 'array',
      default: [],
    },
    uniqueSliderId: {
      type: 'string',
      default: '',
    },
    sectionClass: {
      type: 'string',
      default: 'section-dark-secondary',
    },
    cornerPositionClass: {
      type: 'string',
      default: 'corner-disabled',
    },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-dark-secondary',
    },
    slidesColorClass: {
      type: 'string',
      default: 'slides-dark-primary',
    },
  },
  edit: BlockEdit,
  save: ({ attributes }) => {
    const { slides, uniqueSliderId } = attributes;

    return (
      <section className={attributes.sectionClass}>
        <div
          className={`corner ${attributes.cornerPositionClass} ${attributes.sectionClass.replace(
            'section',
            'corner'
          )} ${attributes.cornerBackgroundClass}`}
        ></div>
        <div
          className={`stepper-slider-wrapper ${attributes.slidesColorClass}`}
        >
          <div className="slider-container">
            <div className="list-wrapper">
              <div className="stepper-container"></div>
              <div
                className="list"
                id={uniqueSliderId}
                data-slider="stepper-slider"
              >
                {slides &&
                  slides.length &&
                  slides.map((slide, index) => (
                    <div
                      className="stepper-slide content-left-top"
                      data-step-title={slide.stepTitle}
                      key={index}
                    >
                      {slide.imgUrl && (
                        <img src={slide.imgUrl} alt={slide.imgAlt || ''} />
                      )}
                      <div className="content">
                        <RichText.Content
                          tagName="p"
                          className="h2-eyebrow"
                          value={slide.eyebrow}
                        />
                        <div>
                          <RichText.Content tagName="h3" value={slide.title} />
                          <RichText.Content
                            tagName="div"
                            className="description"
                            value={slide.description}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  },
});
